export function SeedSprout({ className = "" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 120 160"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      {/* soil line */}
      <line x1="10" y1="135" x2="110" y2="135" stroke="currentColor" strokeOpacity="0.25" strokeWidth="1" strokeDasharray="2 4" />
      {/* seed */}
      <ellipse cx="60" cy="138" rx="6" ry="3.5" fill="currentColor" fillOpacity="0.55" />
      {/* stem — grows */}
      <g className="animate-sprout delay-300 text-[color:var(--color-leaf)]">
        <path
          d="M60 135 C 60 110, 58 95, 60 70"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
        />
      </g>
      {/* leaves — gently sway */}
      <g className="animate-sprout delay-500 text-[color:var(--color-leaf)]">
        <g className="animate-sway origin-bottom" style={{ transformOrigin: "60px 90px" }}>
          <path
            d="M60 92 C 46 86, 38 92, 36 100 C 46 102, 56 100, 60 96 Z"
            fill="currentColor"
            fillOpacity="0.85"
          />
          <path
            d="M60 80 C 74 74, 82 80, 84 88 C 74 90, 64 88, 60 84 Z"
            fill="currentColor"
            fillOpacity="0.85"
          />
        </g>
      </g>
      {/* sun / breath */}
      <circle
        cx="98"
        cy="28"
        r="10"
        className="animate-breathe text-[color:var(--color-leaf)]"
        fill="currentColor"
        fillOpacity="0.15"
      />
      <circle cx="98" cy="28" r="4" fill="currentColor" fillOpacity="0.45" />
    </svg>
  );
}
